<div class="oauth-container">
  <div class="oauth-content">
    <div *ngIf="loading" class="loading">
      <h2>Connecting Google Ads...</h2>
      <p>Please wait while we complete your Google Ads connection.</p>
    </div>

    <div *ngIf="success && !loading" class="success">
      <h2>Google Ads Connected Successfully!</h2>
      <p>Your Google Ads account has been connected. Redirecting you back...</p>
    </div>

    <div *ngIf="error && !loading" class="error">
      <h2>Connection Failed</h2>
      <p>{{ error }}</p>
      <button (click)="router.navigate(['/stores'])" class="btn-primary">
        Back to Stores
      </button>
    </div>
  </div>
</div> 